import { default as Tabs } from './Tabs';

export default Tabs;
